import { render, staticRenderFns } from "./AuthenticationLayout.vue?vue&type=template&id=28358d84&scoped=true"
import script from "./AuthenticationLayout.vue?vue&type=script&lang=js"
export * from "./AuthenticationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28358d84",
  null
  
)

export default component.exports